__webpack_require__.p = "/spartakusfunds/";